import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller, Control, FieldError } from 'react-hook-form';

interface FormSelectProps extends Omit<TextFieldProps, 'name' | 'select'> {
  name: string;
  control: Control<any>;
  children: React.ReactNode;
}

const FormSelect: React.FC<FormSelectProps> = ({ name, control, children, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }: { field: any; fieldState: { error?: FieldError } }) => (
        <TextField
          {...field}
          {...props}
          select
          error={!!error}
          helperText={error?.message || props.helperText}
          fullWidth
          variant="outlined"
          sx={{
            ...props.sx
          }}
        >
          {children}
        </TextField>
      )}
    />
  );
};

export default FormSelect; 